<template lang="pug">
.sales_box
  MobileAov(v-if='isCom', :isCom='isCom')
  PcAov(v-else, :isCom='isCom')
</template>

<script>
import MobileAov from './components/MobileAov.vue'
import PcAov from './components/PcAov.vue'
export default {
  metaInfo() {
    return {
      title:
        'MondoMenu - Create a better ordering experience and drive loyalty to grow your revenue',
      meta: [
        {
          name: 'og:title',
          content:
            'MondoMenu - Create a better ordering experience and drive loyalty to grow your revenue',
        },
        {
          name: 'twitter:title',
          content:
            'MondoMenu - Create a better ordering experience and drive loyalty to grow your revenue',
        },
        {
          name: 'description',
          content:
            'MondoMenu can help you increase your average transaction value by over 40% and allow you to capture orders for preorder, takeaway and delivery',
        },
        {
          name: 'twitter:description',
          content:
            'MondoMenu can help you increase your average transaction value by over 40% and allow you to capture orders for preorder, takeaway and delivery',
        },
        {
          name: 'og:description',
          content:
            'MondoMenu can help you increase your average transaction value by over 40% and allow you to capture orders for preorder, takeaway and delivery',
        },
        { name: 'og:type', content: 'website' },
        { name: 'twitter:card', content: 'summary_large_image' },
      ],
    }
  },

  components: {
    MobileAov,
    PcAov,
  },

  watch: {
    isMobile: {
      immediate: true,
      handler(val) {
        this.isCom = val
      },
    },
  },

  data() {
    return {
      isCom: false,
      isMobile: false,
    }
  },

  created() {
    this.isMobile = this.widthOfDeviceIsIpad()
  },

  beforeMount() {
    window.addEventListener('resize', this._resizeHandler)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this._resizeHandler)
  },

  methods: {
    _resizeHandler() {
      this.isMobile = this.widthOfDeviceIsIpad()
    },

    //  判断是否是 ipad 以下的尺寸
    widthOfDeviceIsIpad(WIDTH = 1024) {
      const { body } = document
      // 获取 body 自身位置和尺寸的合集
      const rect = body.getBoundingClientRect()
      return rect.width - 1 < WIDTH
    },
  },
}
</script>

<style lang="sass" scoped>
.router
  @media screen and (max-width: 1024PX)
    flex-direction: row
</style>
